import { magicLinkClient } from "better-auth/client/plugins"
import { createAuthClient } from "better-auth/react"

export const authClient = createAuthClient({
	baseURL: `${import.meta.env.VITE_PUBLIC_API_URL}/v1/auth`,
	plugins: [magicLinkClient()],
})
